module.exports = "./img/f6917227bf4123aae1417431ef1c69f7.png";